import { Component, OnInit } from "@angular/core";
import AppConstants from "../../constants/AppConstants";
import { ActivatedRoute } from "@angular/router";
import { DocsService } from "../../services/docs.service";

@Component({
  selector: "app-docs",
  templateUrl: "./docs.component.html",
  styleUrls: ["./docs.component.scss"],
})
export class DocsComponent {
  docs = [];
  searchQuery = "";
  count: number;
  readonly DEFAULT_PAGE_SIZE = AppConstants.DEFAULT_PAGE_SIZE;
  readonly DEFAULT_PAGE_SIZE_OPTIONS = AppConstants.DEFAULT_PAGE_SIZE_OPTIONS;
  readonly DEFAULT_PAGINATION_INFO = { pageIndex: 0, pageSize: 10 };
  pageIndex = 0;

  constructor(
    private route: ActivatedRoute,
    private graphqlService: DocsService
  ) {
    route.params.subscribe((val) => {
      this.fetchList(this.DEFAULT_PAGINATION_INFO);
    });
  }

  pageChanged({ pageIndex, pageSize }) {
    this.fetchList(
      {
        pageIndex,
        pageSize,
      },
      this.searchQuery
    );
  }

  private fetchList(pageInfo, searchParam?: string) {
    this.pageIndex = pageInfo.pageIndex;
    const obj = {
      paginationData: {
        pageIndex: pageInfo.pageIndex,
        pageSize: pageInfo.pageSize,
      },
      searchParam: searchParam,
    };
    this.graphqlService.list(obj).subscribe((result) => {
      if (result && result.data) {
        const documents = result.data["documents"];

        // Extract actual document nodes from edges
        this.docs = documents.edges.map((edge) => edge.node);

        // Get total count
        this.count = documents.totalCount;
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/docs/docs.component.ts